import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaExclamationTriangle, FaInfoCircle } from 'react-icons/fa';

const ConfigModal = ({ show, onHide, onSave, currentConfig = {} }) => {
    // Form state - only scheduling configuration
    const [formData, setFormData] = useState({
        updateInterval: 1 // Number of days between updates
    });

    const [nextUpdateDate, setNextUpdateDate] = useState('');
    const [loading, setLoading] = useState(false);

    /**
     * Calculate next update date based on interval (in days)
     */
    const calculateNextUpdateDate = (days) => {
        const now = new Date();
        let nextDate = new Date(now);

        // Add the specified number of days
        nextDate.setDate(now.getDate() + parseInt(days || 1));

        return nextDate.toLocaleDateString('pt-BR');
    };

    /**
     * Load current configuration when modal opens
     */
    useEffect(() => {
        if (show && currentConfig) {
            setFormData({
                updateInterval: currentConfig.updateInterval || 1
            });

            const interval = currentConfig.updateInterval || 1;
            setNextUpdateDate(calculateNextUpdateDate(interval));
        }
    }, [show, currentConfig]);

    /**
     * Handle form input changes
     */
    const handleInputChange = (field, value) => {
        const newFormData = { ...formData, [field]: value };
        setFormData(newFormData);

        // Update next update date when interval changes
        if (field === 'updateInterval') {
            setNextUpdateDate(calculateNextUpdateDate(value));
        }
    };


    /**
     * Handle form submission
     */
    const handleSubmit = async () => {
        try {
            setLoading(true);

            // Validate interval
            if (!formData.updateInterval || formData.updateInterval < 1) {
                alert('Por favor, informe um período válido entre atualizações.');
                return;
            }

            // Prepare config data - only scheduling information
            const configData = {
                updateInterval: formData.updateInterval,
                nextUpdateDate: nextUpdateDate,
                lastConfigured: new Date().toISOString()
            };

            await onSave(configData);
            onHide();
        } catch (error) {
            console.error('Error saving configuration:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            {/* Header with back button */}
            <Modal.Header className='bg-gradient-to-r from-slate-700 to-slate-600 text-white px-6 py-4 flex items-center' style={{
                backgroundColor: '#6c757d',
                color: 'white',
                padding: '12px 20px',
                borderRadius: '8px 8px 0 0',
                marginBottom: '0',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
            }}>

                <span style={{ fontWeight: 'bold' }}>Alerta</span>
                <FaExclamationTriangle />

            </Modal.Header>

            <Modal.Body style={{ padding: '0 30px 30px' }}>
                {/* Alert Section */}

                <div
                    style={{
                        padding: '20px',
                    }}
                >
                    <h6 style={{ fontWeight: 'bold', marginBottom: '15px', color: '#003B6B' }}>Agendamento de Atualizações</h6>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontWeight: 'bold' }}>
                                    Data da próxima atualização programada
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    value={nextUpdateDate}
                                    readOnly
                                    style={{
                                        backgroundColor: 'white',
                                        textAlign: 'center',
                                        fontWeight: 'bold'
                                    }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    Período entre atualizações programadas
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="update-interval-tooltip">
                                                Informe o número de dias entre cada atualização automática.
                                                Somente números inteiros são permitidos (ex: 1, 2, 3, etc.).
                                            </Tooltip>
                                        }
                                    >
                                        <FaInfoCircle
                                            style={{
                                                color: '#007bff',
                                                cursor: 'pointer',
                                                fontSize: '16px'
                                            }}
                                        />
                                    </OverlayTrigger>
                                </Form.Label>
                                <Form.Control
                                    type="number"
                                    min="1"
                                    max="12"
                                    value={formData.updateInterval}
                                    onChange={(e) => {
                                        const value = parseInt(e.target.value) || 1;
                                        handleInputChange('updateInterval', value);
                                    }}
                                    placeholder="Número de dias"
                                    style={{
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                        MozAppearance: 'textfield'
                                    }}
                                    className="no-number-arrows"
                                />
                                <Form.Text className="text-muted" style={{ textAlign: 'center', display: 'block' }}>
                                    {formData.updateInterval === 1 ? '1 dia(s)' : `${formData.updateInterval} dias`}
                                </Form.Text>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mt-4">
                        <Col className="d-flex justify-content-center gap-3">
                            <Button
                                variant="danger"
                                onClick={onHide}
                                style={{
                                    backgroundColor: '#dc3545',
                                    borderColor: '#dc3545',
                                    padding: '10px 30px',
                                    fontWeight: 'bold',
                                    borderRadius: '8px'
                                }}
                            >
                                Voltar
                            </Button>
                            <Button
                                variant="primary"
                                onClick={handleSubmit}
                                disabled={loading}
                                style={{
                                    backgroundColor: '#003B6B',
                                    borderColor: '#003B6B',
                                    padding: '10px 30px',
                                    fontWeight: 'bold',
                                    borderRadius: '8px'
                                }}
                            >
                                {loading ? 'Salvando...' : 'Confirmar'}
                            </Button>
                        </Col>
                    </Row>
                </div>

            </Modal.Body>
        </Modal>
    );
};

export default ConfigModal;